import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppInput from '@nxsys/components/AppInput';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import React, { Ref, useImperativeHandle } from 'react';

type ContactDetailFormProps = {
  formRef?: Ref<ContactDetailFormRef>;
  onSubmit?: (values: ContactDetailValues) => void;
  defaultValues?: Partial<ContactDetailValues>;
};

export type ContactDetailFormRef = {
  submit: () => void;
};

export type ContactDetailValues = {
  forename: string;
  surname: string;
  telephone: string;
  directDial: string;
  email: string;
  alternateEmail: string;
};

const ContactDetailForm: React.FC<ContactDetailFormProps> = ({
  formRef,
  onSubmit,
  defaultValues = {},
}) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm<ContactDetailValues>();

  useImperativeHandle(formRef, () => ({
    submit() {
      form.submit();
    },
  }));

  const onFinish: FormProps['onFinish'] = async (values) => {
    onSubmit?.(values);
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppFormContainer
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      initialValues={defaultValues}
    >
      <Form.Item label={messages['common.forename']} name="forename">
        <AppInput placeholder={messages['form.enter']} />
      </Form.Item>
      <Form.Item label={messages['common.surname']} name="surname">
        <AppInput placeholder={messages['form.enter']} />
      </Form.Item>
      <Form.Item label={messages['common.telephone']} name="telephone">
        <AppInput placeholder={messages['form.enter']} />
      </Form.Item>
      <Form.Item label={messages['common.directDial']} name="directDial">
        <AppInput placeholder={messages['form.enter']} />
      </Form.Item>
      <Form.Item
        label={messages['common.emailID']}
        name="email"
        rules={[{ type: 'email', message: messages['form.enterValidEmail'] }]}
      >
        <AppInput
          placeholder={messages['form.enter']}
          allowCapitalize={false}
        />
      </Form.Item>
      <Form.Item
        label={messages['common.alternateEmailID']}
        name="alternateEmail"
        rules={[{ type: 'email', message: messages['form.enterValidEmail'] }]}
      >
        <AppInput
          placeholder={messages['form.enter']}
          allowCapitalize={false}
        />
      </Form.Item>
    </AppFormContainer>
  );
};

export default ContactDetailForm;
